export const MAX_WIDTH  = "1260px";


export const PP_BUTTON_MAX_WIDTH = "352px";
export const PP_BUTTON_MAX_HEIGHT = "56px";

// values for the margin properties
export const PX_0 = "0px";
export const PX_5 = "5px";
export const PX_10 = "10px";
export const PX_16 = "16px";
export const PX_20 = "20px";
export const PX_25 = "25px";
export const PX_26 = "26px";
export const PX_30 = "30px";


//Responsive value for devices

export const IS_MOBILE_DEVICE = "480px";
export const IS_TAB_DEVICE = "768px";